import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { useContent } from '../hooks/useContent';

const CTASection = () => {
  const { t } = useLanguage();
  const { pick } = useContent('cta', {
    explore_title_en: t.cta.exploreTitle, explore_title_el: t.cta.exploreTitle,
    explore_desc_en: t.cta.exploreDesc, explore_desc_el: t.cta.exploreDesc,
    explore_cta_en: t.cta.exploreCta, explore_cta_el: t.cta.exploreCta,
    plan_title_en: t.cta.planTitle, plan_title_el: t.cta.planTitle,
    plan_desc_en: t.cta.planDesc, plan_desc_el: t.cta.planDesc,
    plan_cta_en: t.cta.planCta, plan_cta_el: t.cta.planCta,
  });

  return (
    <section className="bg-gradient-to-b from-[#0a0e27] to-[#050811] py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden">
          {/* Gradient background */}
          <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/10 via-blue-500/10 to-purple-500/10 rounded-3xl"></div>
          <div className="absolute inset-0 backdrop-blur-3xl rounded-3xl"></div>
          
          {/* Content */}
          <div className="relative grid md:grid-cols-2 gap-12 p-12 md:p-16">
            <div className="flex flex-col justify-center">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                {pick('explore_title')}
              </h2>
              <p className="text-white/70 text-lg mb-6">
                {pick('explore_desc')}
              </p>
              <div>
                <Button asChild size="lg" className="bg-white text-black hover:bg-white/90 group">
                  <a data-testid="cta-explore-mailto" href="mailto:contact@heliophant.com?subject=Helio Market Algo - Explore&body=%CE%93%CE%B5%CE%B9%CE%B1%20%CF%83%CE%B1%CF%82%2C%0A%0A%CE%98%CE%B1%20%CE%AE%CE%B8%CE%B5%CE%BB%CE%B1%20%CE%BD%CE%B1%20%CE%BC%CE%AC%CE%B8%CF%89%20%CF%80%CE%B5%CF%81%CE%B9%CF%83%CF%83%CF%8C%CF%84%CE%B5%CF%81%CE%B1.%0A%0A%CE%95%CF%85%CF%87%CE%B1%CF%81%CE%B9%CF%83%CF%84%CF%8E">
                    {pick('explore_cta')}
                    <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
                  </a>
                </Button>
              </div>
            </div>
            
            <div className="flex flex-col justify-center">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                {pick('plan_title')}
              </h2>
              <p className="text-white/70 text-lg mb-6">
                {pick('plan_desc')}
              </p>
              <div>
                <Button asChild size="lg" className="bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white group">
                  <a data-testid="cta-plan-mailto" href="mailto:contact@heliophant.com?subject=Helio Market Algo - Plan&body=%CE%93%CE%B5%CE%B9%CE%B1%20%CF%83%CE%B1%CF%82%2C%0A%0A%CE%95%CE%BD%CE%B4%CE%B9%CE%B1%CF%86%CE%AD%CF%81%CE%BF%CE%BC%CE%B1%CE%B9%20%CE%B3%CE%B9%CE%B1%20%CE%AD%CE%BD%CE%B1%20%CF%80%CE%BB%CE%AC%CE%BD%CE%BF.%0A%0A%CE%95%CF%85%CF%87%CE%B1%CF%81%CE%B9%CF%83%CF%84%CF%8E">
                    {pick('plan_cta')}
                    <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
                  </a>
                </Button>
              </div>
            </div>
          </div>
          
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-cyan-500/20 rounded-full blur-3xl -z-10"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-blue-500/20 rounded-full blur-3xl -z-10"></div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;